import ApplicationSurface from "../../../components/application/ApplicationSurface";
import { validateProgramEvidencePayload } from "./programEvidenceContract";

const EvidenceComponent = ({ component }) => (
  <article className="av-program-evidence-component">
    <h4>{component.label}</h4>
    {component.description ? <p>{component.description}</p> : null}
    {component.type === "status" ? <p className={`av-program-evidence-status av-program-evidence-status--${component.value}`}>{({
      available: "Available",
      derivable_projection_missing: "Derivable — projection not yet implemented",
      not_yet_captured: "Not yet captured",
      methodology_pending: "Methodology pending",
      sample_pending: "Sample pending",
    })[component.value] || component.value}</p> : null}
    {component.type === "metric" ? <p>{component.value}{component.unit ? ` ${component.unit}` : ""}</p> : null}
    {component.type === "metadata" ? (
      <dl>{component.items.map(item => <div key={item.label}><dt>{item.label}</dt><dd>{item.value}</dd></div>)}</dl>
    ) : null}
  </article>
);

export default function ProgramEvidenceComponents({ evidence, heading = "Program evidence", showAvailabilitySummary = true }) {
  if (!validateProgramEvidencePayload(evidence) || evidence.availability === "not_supported") return null;
  if (evidence.availability === "unavailable") {
    return <ApplicationSurface><p>Program evidence is currently unavailable.</p></ApplicationSurface>;
  }
  return (
    <ApplicationSurface>
      <h3>{heading}</h3>
      {showAvailabilitySummary && evidence.availability === "partial" ? <p>Partial Program evidence is available.</p> : null}
      <div className="av-program-evidence-components">
        {evidence.components.map(component => <EvidenceComponent component={component} key={component.key} />)}
      </div>
    </ApplicationSurface>
  );
}
